import React from 'react';
import Modal from './Modal';

export default function ConfirmDialog({ isOpen, onClose, onConfirm, title = 'Confirm', message, loading }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger" onClick={onConfirm} disabled={loading}>
            {loading ? 'Please wait…' : 'Confirm'}
          </button>
        </>
      }
    >
      <p style={{ margin: 0, color: 'var(--gray-600)' }}>{message}</p>
    </Modal>
  );
}